import { createRoot } from 'react-dom/client';
import DmbPlugin from './app';

const container = document.querySelector('#app');

if (!container) {
  throw new Error('DMB requires an #app container.');
}

createRoot(container).render(<DmbPlugin />);